import { LandingPage } from "./Pages/index";

function App() {
  return (
    <div>
      <LandingPage />
    </div>
  );
}

export default App;
